import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';

import Highcharts from 'highcharts';


Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});

const founder = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['Male', 'Female']
  },
  yAxis: {
      min: 0,
      title: {
          text: 'Amount of founders'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'normal'
      }
  },
  series: [{
      name: 'Male',
      data: [449, 0]},
      {
      name: 'Female',
      data: [0, 40]

    }]
}


const vc = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['Male', 'Female']
  },
  yAxis: {
      min: 0,
      title: {
          text: 'Amount of founders'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'normal'
      }
  },
  series: [{
      name: 'Male',
      data: [56, 0]},
      {
      name: 'Female',
      data: [0, 3]

    }]
}

const survey = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['VC/Investor', 'Founder', 'Community builder']
  },
  yAxis: {
      min: 0,
      title: {
          text: '% of responses'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'percent'
      }
  },
  series: [{
      name: 'Yes',
      data: [44, 63, 75]},
      {
      name: 'No',
      data: [56, 37, 25]

    }]
}

const survey2 = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['VC/Investor', 'Founder', 'Community builder']
  },
  yAxis: {
      min: 0,
      title: {
          text: '% of responses'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'percent'
      }
  },
  series: [{
      name: '90%',
      data: [4, 4, 13]
    },
      {
      name: '75%',
      data: [0, 13, 44]
    },
      {
      name: '50%',
      data: [38, 37, 25]
    },
      {
      name: '25%',
      data: [29, 41, 19]
    },
      {
      name: '10%',
      data: [25, 2, 0]
      },
      {
      name: '0%',
      data: [4, 2, 0]
    }]
}


const survey3 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [{
        name: 'Not sure',
        data: [0, 7, 4]
    },{
        name: 'It is not discussed',
        data: [25, 44, 46]
    },{
        name: 'It is somewhat of an issue',
        data: [44, 35, 38]
    },{
        name: 'It is a major issue',
        data: [31, 14, 13]
    }]
}

const survey4 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [{
        name: 'Strongly disagree',
        data: [0, 16, 24]
    },{
        name: 'Disagree',
        data: [6, 38, 16]
    },{
        name: 'Neutral',
        data: [56, 36, 28]
    },{
        name: 'Agree',
        data: [31, 5, 20]
    },{
        name: 'Strongly agree',
        data: [6, 5, 12]
    }]
}


const survey5 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Male founders', 'Female founders']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [{
        name: 'Strongly disagree',
        data: [17, 14]
    },{
        name: 'Disagree',
        data: [43, 21]
    },{
        name: 'Neutral',
        data: [38, 30]
    },{
        name: 'Agree',
        data: [0, 21]
    },{
        name: 'Strongly agree',
        data: [2, 14]
    }]
}



export class ChapterFiftyFour extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

          <TextHolder text="Report after report in recent years by leading management consultancies like McKinsey & Co. have highlighted that companies with more gender and ethnic diversity are better able to win top talent, improve employee satisfaction and enjoy above average profitability." />
          <TextHolder text="In SEA specifically, for years women have been appointed to leadership positions in tech-related organizations in both the private and public sectors for many years. Global firms such as IBM and Salesforce have started diversity programs also applicable to their SEA staff." />
          <TextHolder text="However, progress has been limited. Women still tend to be underrepresented in leadership positions at both tech startups and VC firms. The results of our survey show there is support for gender diversity, yet there is relatively little discussion of the issue within the tech ecosystem. This is surprising given current events like the #MeToo movement overseas, which have given the issue a good airing around the world." />

          <TextHolder text="" />




          <Highchartscomponent chartsText="Gender diversity among founders" source={<p>Source: <a href="https://craft.co">Craft</a>, Slush Singapore analysis</p>}  notes="Notes: Consists of an analysis of a representative sample of 500 active, VC-funded startups. Gender data not attained for small percentage of founders."
            options={founder}/>

          <Highchartscomponent chartsText="Gender diversity among VCs" source={<p>Source: <a href="https://craft.co">Craft</a>, Slush Singapore analysis</p>}  notes="Notes: Consists of an analysis of a representative sample of 21 active VCs with partner presence in SE Asia"
            options={vc}/>


          <Highchartscomponent chartsText="Is there a female on your executive team (e.g. founder, GP, or C-level exec)?"
            options={survey} source="Source: 2018 State of SE Asian Tech Survey" />


            <TextHolder text="" />
          <TextHolder text="However, the survey findings show a gleam of light. Most respondents said their firm had at least one woman on its executive team. However, that still left 40 percent of respondents at organizations with all-male leadership. These are pertinent issues that will perhaps be pursued in the next edition of this report."/>

          <TextHolder text="Among employees, gender diversity varied greatly. Fifty-eight percent of VCs/investors and 45 percent of founders said that women comprised less than half of their workforce. Community builders have the best employment figures; 57 percent said that their workforce was at least three-fourths female."/>
          <TextHolder text="" />

          <Highchartscomponent chartsText="Approximately what percentage of your workforce is female?"
            options={survey2} source="Source: 2018 State of SE Asian Tech Survey" />


            <Highchartscomponent chartsText="How do you think gender diversity is viewed in the SEA tech industry?"
              options={survey3} source="Source: 2018 State of SE Asian Tech Survey" />


              <TextHolder text="" />
              <TextHolder text="The fact that gender diversity is little discussed in the tech industry is the most eye-opening finding of our survey. It could mean that culturally, gender diversity is a sensitive topic which requires a light tread"/>
              <TextHolder text="To test respondents’ attitudes towards encouraging gender diversity, our survey asked whether investors should fund more companies with female founders. The response was mostly negative. Most respondents believed that gender in the founding team should not be an important consideration for investors. "/>
              <TextHolder text="Interestingly, it was founders themselves who were against the idea: 54 percent of them disagreed or strongly disagreed. However, that response was split along gender lines. Thirty-five percent of female founders supported this move, compared to only 2 percent of male founders."/>
              <TextHolder text="" />
              <Highchartscomponent chartsText="Respond to the following statement: The gender composition of the executive team should be a factor in choosing to invest in a company"
                options={survey4} source="Source: 2018 State of SE Asian Tech Survey" />



                <Highchartscomponent chartsText="Respond to the following statement: The gender composition of the executive team should be a factor in choosing to invest in a company"
                  options={survey5} source="Source: 2018 State of SE Asian Tech Survey" />
                  <TextHolder text="" />

                  <TextHolder text="Asked what can be done to support more women to move into the tech industry, Shariha Khalid Erichsen of Impact Hub Kuala Lumpur said: “Investors, governments, and other stakeholders can support women in tech by unlocking more capital, providing capacity building programs tailored to the needs of women in the industry. They should also actively share stories of women tech entrepreneurs to inspire others, for example, by creating role models.”"/>
                  <TextHolder text="" />



          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/54.js